import src from "IMAGE";
export default { src, width: 71, height: 231, blurWidth: 2, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAAPUlEQVR42lXGsQkAIAwF0UAGSqZLJhCcQdxOrEW0E8Sf0oMHR6qaRSSRu28zm8TMFw6hC/90aDEVSsyC8QDFbxG0ywCg/gAAAABJRU5ErkJggg=="};
